import React from "react";
import { Dialog } from "primereact/dialog";
import "./Filter.css";

const FilterPreviewDialog = ({ visible, onHide, previewResults }) => {
  // Extract filtered results from the response
  const filteredResults = previewResults?.filteredResults || {};
  const totalResults = Object.values(filteredResults).reduce(
    (sum, values) => sum + (Array.isArray(values) ? values.length : 0),
    0
  );

  return (
    <Dialog
      visible={visible}
      onHide={onHide}
      header="Filter Results Preview"
      style={{ width: "900px" }}
      modal
    >
      <div className="preview-content">
        <div className="preview-header">
          <h3>Found {totalResults} matching value(s)</h3>
        </div>
        {Object.keys(filteredResults).length > 0 ? (
          <div className="preview-results">
            {Object.entries(filteredResults).map(([field, values], index) => (
              <div key={index} className="preview-card">
                <div className="preview-card-header">
                  <strong>{field}</strong>
                  <span className="preview-card-date">
                    {Array.isArray(values) ? values.length : 0} result(s)
                  </span>
                </div>
                <div className="preview-card-body">
                  {Array.isArray(values) && values.length > 0 ? (
                    <div className="preview-field">
                      <div className="preview-values-list">
                        {values.map((value, idx) => (
                          <span key={idx} className="preview-value-tag">
                            {String(value)}
                          </span>
                        ))}
                      </div>
                    </div>
                  ) : (
                    <div className="preview-field">
                      <span className="preview-field-value">No values</span>
                    </div>
                  )}
                </div>
              </div>
            ))}
          </div>
        ) : (
          <div className="no-results">
            <i
              className="pi pi-info-circle"
              style={{ fontSize: "3rem", color: "#999" }}
            />
            <p>No records match the filter criteria</p>
          </div>
        )}
      </div>
    </Dialog>
  );
};

export default FilterPreviewDialog;
